import { AmountSuperScript } from "components/design/AmountSuperScript";
import { TableUI } from "components/design/TableUI";
import { Button } from "components/DesignSystem/Button/Button";
import FocusBlock from "components/DesignSystem/FocusBlock/FocusBlock";
import Table from "components/DesignSystem/Table/V2/Table";
import { DeleteIcon } from "components/icons/delete";
import { EditPencil } from "components/icons/EditPencil";
import { FOCUS_BLOCK_PLACEMENT } from "constants/focusBlock";
import { useState } from "react";
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from "react-table-8.10.7";
import { Invoice, InvoiceItem } from "types/Models/invoice";
import { VendorBill } from "types/Models/vendorBills";
import { formatDate } from "utils/formatDate";
import { lineItemColumns } from "./LineItemTable";

export const LineItemInfoTable = ({
  invoice,
  showCategory = true,
}: {
  invoice: Invoice | VendorBill;
  isActionVisible?: boolean;
  handleItemDelete?: (id: string) => void;
  handleItemEdit?: (item: InvoiceItem) => void;
  invoiceItem?: InvoiceItem | null;
  renderEditForm?: (item: InvoiceItem) => React.ReactNode;
  isUpdatingTableItem?: boolean;
  showCategory?: boolean;
}) => {
  const currency = invoice?.currency;

  const columns = lineItemColumns({ currency, showCategory });

  const table = useReactTable({
    columns,
    data: (invoice?.invoice_items as InvoiceItem[]) || [],
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <>
      <TableUI
        size="regular"
        table={table}
        children={({ row }) => {
          const item = row.original;
          return (
            <Table.Row key={row.id}>
              {row.getVisibleCells().map((cell) => (
                <Table.Cell key={cell.id}>
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </Table.Cell>
              ))}
            </Table.Row>
          );
        }}
      />
    </>
  );
};
